import React from 'react'
import styled from 'styled-components'
import CMS from '@talus-analytics/library.airtable-cms'

import Topic from './Topic'
import useBarChartData from 'dataHooks/useBarChartData'
import useLandingPageData from 'cmsHooks/useLandingPageData'

const Header = styled.h1`
  text-align: center;
`
const Grid = styled.div`
  margin-top: 50px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  row-gap: 1rem;
  column-gap: 1rem;
`
const Container = styled.div``

const TopicGrid = () => {
  const topicData = useBarChartData().group
  const data = useLandingPageData()

  return (
    <Container>
      <Header>
        <CMS.Text data={data} name="Second header" />
      </Header>
      <Grid>
        {topicData.map(topic => (
          <Topic key={topic.fieldValue} name={topic.fieldValue} />
        ))}
      </Grid>
    </Container>
  )
}

export default TopicGrid
